import React from "react";

const DesktopIcon = ({ Icon, label, onClick, isMobile }) => {
  return (
    <div
      className="flex flex-col items-center justify-center cursor-pointer py-3"
      onClick={onClick}
    >
      <div
        className={`rounded-md bg-blue-500 ${
          isMobile ? "p-4" : "p-4"
        } text-white transition-all duration-150 hover:bg-blue-600 hover:opacity-80 hover:scale-105`}
      >
        <Icon className={isMobile ? "text-3xl" : "text-3xl"} />
      </div>
      <p
        className={`mt-3 text-center font-medium ${
          isMobile ? "text-lg" : "text-base"
        }`}
      >
        {label}
      </p>
    </div>
  );
};

export default DesktopIcon;
